import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconCardPortraitLarge = function IconCardPortraitLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 54"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00204D",
    d: "M21.716.5H57.5v53H21.716z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    stroke: "#00204D",
    d: "M8.786 17.125h24.736V53.5H8.786z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00204D",
    d: "M.5 30.658h15.571v22.843H.5z"
  }));
};